module.exports = __webpack_public_path__ + "public/SiteIcons/waving-hand.png?b59189c0";